import AdminsPage from "@Pages/AdminsPage";
import BpContactPersonListPage from "@Pages/BpContactPersonListPage";
import DashboardPage from "@Pages/Dashboard";
import LoginPage from "@Pages/Login";
import OrganizationOverviewPage from "@Pages/OrganizationOverviewPage";
import OrganizationsPage from "@Pages/OrganizationsPage";
import UnauthorizedPage from "@Pages/UnauthorizedPage";
import UsersPage from "@Pages/UsersPage";
import { RootState } from "@Store";
import { selectIsAuthenticated } from "@Store/App/selectors";
import { appUserDataRequest } from "@Store/AppUser/actions";
import { selectIsSystemAdmin } from "@Store/AppUser/selectors";
import { selectIsAdminOfAtLeaseOneOrganization } from "@Store/Organizations/selectors";
import { useAppDispatch, useAppSelector } from "@hooks";
import { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

function MainRouter() {
  const dispatch = useAppDispatch();

  const { isAuthenticated, isSystemAdmin, isAdminOfAtLeaseOneOrganization } =
    useAppSelector((state: RootState) => ({
      isAuthenticated: selectIsAuthenticated(state),
      isSystemAdmin: selectIsSystemAdmin(state),
      isAdminOfAtLeaseOneOrganization:
        selectIsAdminOfAtLeaseOneOrganization(state),
    }));

  useEffect(() => {
    if (!isAuthenticated) return;

    dispatch(appUserDataRequest());
  }, [dispatch, isAuthenticated]);

  if (!isAuthenticated) {
    return (
      <Switch>
        {/* <Route exact path='/' render={() => <Redirect to='/login' />} /> */}
        <Route path="/login">
          <LoginPage />
        </Route>
        {/* TODO: what this page for ? */}
        {/* <Route path='/userinvitation' key='1'>
          <UserInvitationPage />
        </Route> */}
        <Redirect to="/login" />
      </Switch>
    );
  } else if (isSystemAdmin) {
    return (
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
        <Route
          exact
          path="/login"
          render={() => <Redirect to="/dashboard" />}
        />
        <Route path="/dashboard" component={DashboardPage} />
        <Route path="/bpContactPersons" component={BpContactPersonListPage} />
        <Route path="/organizations" component={OrganizationsPage} />
        <Route path="/organization/:orgId" key="orga/single">
          <Switch>
            <Route
              exact
              path="/organization/:orgId/overview"
              component={OrganizationOverviewPage}
            />
            {/*<Route*/}
            {/*  exact*/}
            {/*  path="/organization/:orgId/data"*/}
            {/*  component={OrganizationPage}*/}
            {/*/>*/}
            <Route
              exact
              path="/organization/:orgId/admins"
              component={AdminsPage}
            />
            {/*<Route path="/organization/:orgId/teams">*/}
            {/*  <Switch>*/}
            {/*    <Route*/}
            {/*      exact*/}
            {/*      path="/organization/:orgId/teams"*/}
            {/*      component={TeamsPage}*/}
            {/*    />*/}
            {/*    <Route*/}
            {/*      path="/organization/:orgId/teams/:teamId"*/}
            {/*      component={TeamPage}*/}
            {/*    />*/}
            {/*  </Switch>*/}
            {/*</Route>*/}
            <Route
              exact
              path="/organization/:orgId/users"
              component={UsersPage}
            />
            <Route
              path="/organization/:orgId/*"
              render={() => <Redirect to="/dashboard" />}
            />
          </Switch>
        </Route>
        <Redirect to="/dashboard" />
      </Switch>
    );
  } else if (isAdminOfAtLeaseOneOrganization) {
    return (
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
        <Route
          exact
          path="/login"
          render={() => <Redirect to="/dashboard" />}
        />
        <Route path="/dashboard" component={DashboardPage} />
        <Route path="/bpContactPersons" component={BpContactPersonListPage} />
        <Route path="/organization/:orgId" key="orga/single">
          <Switch>
            <Route
              exact
              path="/organization/:orgId/overview"
              component={OrganizationOverviewPage}
            />
            {/*<Route*/}
            {/*  exact*/}
            {/*  path="/organization/:orgId/data"*/}
            {/*  component={OrganizationPage}*/}
            {/*/>*/}
            <Route
              exact
              path="/organization/:orgId/admins"
              component={AdminsPage}
            />
            {/*<Route path="/organization/:orgId/teams">*/}
            {/*  <Switch>*/}
            {/*    <Route*/}
            {/*      exact*/}
            {/*      path="/organization/:orgId/teams"*/}
            {/*      component={TeamsPage}*/}
            {/*    />*/}
            {/*    <Route*/}
            {/*      path="/organization/:orgId/teams/:teamId"*/}
            {/*      component={TeamPage}*/}
            {/*    />*/}
            {/*  </Switch>*/}
            {/*</Route>*/}
            <Route
              exact
              path="/organization/:orgId/users"
              component={UsersPage}
            />
            <Route
              path="/organization/:orgId/*"
              render={() => <Redirect to="/dashboard" />}
            />
          </Switch>
        </Route>
        <Redirect to="/dashboard" />
      </Switch>
    );
  } else {
    return (
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
        <Route
          exact
          path="/login"
          render={() => <Redirect to="/dashboard" />}
        />
        <Route path="/dashboard" component={UnauthorizedPage} />
        <Redirect to="/dashboard" />
      </Switch>
    );
  }
}

export default MainRouter;
